var _image;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOtherLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 200,
    height: 200,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADIAgMAAADQNkYNAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAACVBMVEUAAADijSn///9MHeHM AAAAAnRSTlMA/iyWEiMAAAABYktHRAJmC3xkAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH 5wgDBwMTT4xhLQAAANlJREFUaN7tlcsNhDAMRMkhJdBPSuCA+29lVwmsR/kAQqy4vHeyRh5nCCRM EwAAAAAAAADAG8y27mUwSx25JprZstXf0jpyu8ivL5j3iVyT27Y4uW1t5F6ufXQurZG7ucroMrmM FrnBfHSZXEaL/IBlC5PTlDA5jcojy+IWO7FEsZhbVH7QsoolHVtmtwSxiIzlDcvgVe6Whz+YG5bk lrWSa24cscFBDiJftBxeF7Pv/9VLKcrOyGSV+8+ffMXzC3aSAFHaxrkOfxaDRe78kgAAAAAAAAAA /soHhdjn3ddjbUcAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDgtMDNUMDU6MDM6MTkrMDI6MDAQ rucTAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTA4LTAzVDA1OjAzOjE5KzAyOjAwYfNfrwAAAABJ RU5ErkJggg=="
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtherLogo);
export default __webpack_public_path__ + "static/media/other-logo.12229c93f464e4864f46bad37326f344.svg";
export { ForwardRef as ReactComponent };